import React from "react";
import { FlexCenter } from "../../../../../layout/FlexCenter/FlexCenter";
import { Spacing } from "../../../../../layout/Spacing/Spacing";
import { SpacingCustom } from "../../../../../layout/Spacing/SpacingCustom";
import { Loader } from "../../../../../shared/Loader/Loader";
import { TextCustom } from "../../../../../ui/TextCustom";

interface IAiAnalyzerProcessingProps {
    isLoading: boolean;
    message: string
}

export const AiAnalyzerProcessing: React.FC<IAiAnalyzerProcessingProps> = ({isLoading, message}) => {

    return (
        <>
            {isLoading && (
                <SpacingCustom marginTop={1}>
                    <Spacing marginSpacing="none" paddingSpacing="s">
                        <FlexCenter gap={1} direction="v" position="start">
                            <Loader width={16} height={16} color="accent-green" hasText={false} />
                            <TextCustom color="grey-dark">{message}</TextCustom>
                        </FlexCenter>
                    </Spacing>
                </SpacingCustom>
            )}
        </>
    )
}